var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.22244 5.50914C3.07369 5.32496 3.02396 5.08569 3.08829 4.86369L3.68737 2.79639C3.79993 2.40797 4.22246 2.18412 4.63113 2.29639C5.03979 2.40867 5.27983 2.81456 5.16727 3.20297L4.84139 4.32751L6.06837 4.31866C6.49216 4.31561 6.84265 4.64088 6.8512 5.04519C6.85975 5.44949 6.52314 5.77972 6.09934 5.78278L3.84373 5.79904C3.6015 5.80079 3.37119 5.69332 3.22244 5.50914Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8865 10.5836C13.0215 10.7785 13.0535 11.0213 12.9727 11.2384L12.2214 13.2574C12.0803 13.6366 11.6425 13.8287 11.2435 13.6865C10.8445 13.5442 10.6354 13.1215 10.7765 12.7423L11.1843 11.6463L9.96251 11.5677C9.53978 11.5406 9.21362 11.1909 9.23402 10.7869C9.25442 10.3828 9.61365 10.0772 10.0364 10.1044L12.2872 10.2492C12.5292 10.2647 12.7514 10.3888 12.8865 10.5836Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.14454 3.80811C6.86733 3.80811 5.73139 4.37542 4.9822 5.26074C4.71462 5.57693 4.24139 5.61634 3.9252 5.34877C3.60901 5.08119 3.56959 4.60796 3.83717 4.29176C4.864 3.07836 6.41486 2.30811 8.14454 2.30811C11.2153 2.30811 13.736 4.74217 13.736 7.783C13.736 8.19722 13.4003 8.533 12.986 8.533C12.5718 8.533 12.236 8.19722 12.236 7.783C12.236 5.60486 10.4216 3.80811 8.14454 3.80811Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.05542 7.0332C3.46963 7.0332 3.80542 7.36899 3.80542 7.7832C3.80542 9.92745 5.69366 11.7581 8.14117 11.7581C9.31024 11.7581 10.3629 11.3348 11.1372 10.6556C11.4486 10.3825 11.9225 10.4135 12.1956 10.7249C12.4688 11.0364 12.4377 11.5102 12.1263 11.7833C11.079 12.7019 9.67501 13.2581 8.14117 13.2581C4.97111 13.2581 2.30542 10.8579 2.30542 7.7832C2.30542 7.36899 2.64121 7.0332 3.05542 7.0332Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.5ae91b798f07cba8f8ce87bef5f6b987.svg";
export { ForwardRef as ReactComponent };